import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  BackgroundColor,
  BackgroundColorOnCollapse,
} from "oc/components/requests-messages-card/requests-messages-card.style";

interface MyHrDataRequestSubCollapseHeaderProps {
  handleExpandClick: () => void;
  expanded: boolean;
  label: string;
  badge: React.ReactNode;
  data: any[]; // Replace 'any' with a more specific type if possible
  isMobile: boolean;
  type?: string;
}

export const MyHrDataRequestSubCollapseHeader = ({
  handleExpandClick,
  expanded,
  label,
  badge,
  data,
  isMobile,
  type,
}: MyHrDataRequestSubCollapseHeaderProps) => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        component={expanded ? BackgroundColorOnCollapse : BackgroundColor}
        padding="16px"
        type={type}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="contents" />
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems={isMobile ? "column" : "center"}
          >
            <Box width="16px" />
            <Typography
              variant="body1"
              style={{
                color: theme.palette.gray80.main,
              }}
            >
              {label}
            </Typography>
            <Box width="16px" />
            {isMobile && <Box height="8px" />}
            <Box
              style={{
                border: `1px solid ${theme.palette.gray80.main}`,
                borderRadius: 12,
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 2,
                paddingBottom: 2,
                color: theme.palette.gray80.main,
              }}
            >
              {badge}
            </Box>
            <Box width="15px" />
            <Box paddingRight="28px" />
          </Box>
          <IconButton
            onClick={data?.length === 0 && type === "attachments" ? undefined : handleExpandClick}
            id={`other-collapse-button-${label}`}
            disabled={data?.length === 0 && type === "attachments"}
            aria-expanded={expanded}
            aria-label="show more"
            style={
              expanded
                ? {
                  padding: 0,
                  transform: "rotate(180deg)",
                }
                : {
                  padding: 0,
                }
            }
          >
            <ExpandMore />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default MyHrDataRequestSubCollapseHeader;
